import loadable from '@loadable/component';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {Text, View} from 'react-native';
import styles from './Option.style';
const SVG = loadable(() => import('../../../../../../imports/svg'));

export default function Option(props) {
  const {containerStyle, context, children, icon} = props;
  const {t} = useTranslation();
  return (
    <View style={[styles.container, containerStyle]}>
      <View style={styles.icon}>
        <SVG name={icon ?? 'squareArrowLeft'} height={30} width={30} />
      </View>
      <Text style={styles.context}>{t(context)}</Text>
      {children}
    </View>
  );
}
